import { num } from "@/lib/format";
import { fabricTotals, metersLabel } from "@/lib/cutTickets";

const summarize = (tickets) => {
  const by = {};
  tickets.forEach((t) => {
    const a = by[t.sheet_id] || (by[t.sheet_id] = { name: t.sheet_name, code: t.code, count: 0, pieces: 0, meters: 0, markers: [], discharged: 0 });
    a.count += 1; a.pieces += t.pieces; a.meters += t.meters; a.markers.push(...(t.markers || [])); a.discharged += t.discharged_at ? 1 : 0;
  });
  return Object.values(by).sort((a, b) => b.pieces - a.pieces);
};

export const SeasonCutSummary = ({ tickets }) => {
  const rows = summarize(tickets);
  const tot = rows.reduce((s, r) => ({ count: s.count + r.count, pieces: s.pieces + r.pieces, meters: s.meters + r.meters }), { count: 0, pieces: 0, meters: 0 });
  return (
    <div className="overflow-x-auto rounded-md border border-border" data-testid="cut-summary">
      <table className="w-full text-sm">
        <thead><tr className="border-b border-border text-xs text-muted-foreground">
          <th className="p-3 text-left font-medium">Articolo</th><th className="p-3 text-right font-medium">Tagliati</th><th className="p-3 text-right font-medium">Capi</th>
          <th className="p-3 text-right font-medium">Metri</th><th className="p-3 text-left font-medium">Metri per tessuto</th>
        </tr></thead>
        <tbody>
          {rows.map((r) => (
            <tr key={`${r.name}-${r.code}`} className="border-b border-border/50" data-testid={`cut-summary-row-${r.code || r.name}`}>
              <td className="p-3"><p className="font-medium">{r.name}</p><p className="text-xs text-muted-foreground">{r.code || "Senza codice"}{r.discharged ? ` · ${r.discharged} con tessuto scaricato` : ""}</p></td>
              <td className="p-3 text-right">{r.count}</td><td className="p-3 text-right font-semibold">{num(r.pieces)}</td><td className="p-3 text-right font-semibold">{metersLabel(r.meters)}</td>
              <td className="p-3 text-xs text-muted-foreground">{fabricTotals(r.markers).map(([f, m]) => `${f}: ${metersLabel(m)}`).join(" · ")}</td>
            </tr>
          ))}
          <tr className="bg-secondary/40 font-semibold"><td className="p-3">Totale stagione</td><td className="p-3 text-right" data-testid="cut-summary-count">{tot.count}</td>
            <td className="p-3 text-right" data-testid="cut-summary-pieces">{num(tot.pieces)}</td><td className="p-3 text-right" data-testid="cut-summary-meters">{metersLabel(tot.meters)}</td><td /></tr>
        </tbody>
      </table>
    </div>
  );
};
